// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicV1ChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequestSchema {
  /** Секция, из которой нужно переместить все чаты в архив **/
  section: ESection;
}

export enum ESection {
  /** Раздел "Сообщения" **/
  'Main' = 'main',
  /** Раздел "Непрочитанные" **/
  'Unread' = 'unread',
}
